import { CheckCircleIcon } from "@chakra-ui/icons";
import { List, ListIcon, ListItem } from "@chakra-ui/react";

export interface AdvertisingListProps {
  listItems: string[];
}

export const AdvertisingList = ({ listItems }: AdvertisingListProps) => {
  return (
    <List px="5" spacing="3" pb="5">
      {listItems.map((item, idx) => (
        <ListItem key={idx}>
          <ListIcon as={CheckCircleIcon} color="green.700" />
          {item}
        </ListItem>
      ))}
    </List>
  );
};
